import bundesliga_background from 'assets/regularCompetition/bundesliga.jpg';
import bundesliga_logo from 'assets/regularCompetition/bundesliga.svg';
import bundesliga_header from 'assets/regularCompetition/bundesliga_header.jpg';
import bundesliga_header_desktop from 'assets/regularCompetition/bundesliga_header_desktop.jpg';
import challenger_background from 'assets/regularCompetition/challenger.jpg';
import challenger_logo from 'assets/regularCompetition/challenger.svg';
import challenger_header from 'assets/regularCompetition/challenger_header.jpg';
import challenger_header_desktop from 'assets/regularCompetition/challenger_header_desktop.jpg';
import challenger_icon from 'assets/regularCompetition/challenger_icon.svg';
import champion_background from 'assets/regularCompetition/champion.jpg';
import champion_logo from 'assets/regularCompetition/champion.svg';
import champion_header from 'assets/regularCompetition/champion_header.jpg';
import champion_header_desktop from 'assets/regularCompetition/champion_header_desktop.jpg';
import champion_icon from 'assets/regularCompetition/champion_icon.svg';
import contender_background from 'assets/regularCompetition/contender.jpg';
import contender_logo from 'assets/regularCompetition/contender.svg';
import contender_header from 'assets/regularCompetition/contender_header.jpg';
import contender_header_desktop from 'assets/regularCompetition/contender_header_desktop.jpg';
import contender_icon from 'assets/regularCompetition/contender_icon.svg';
import laliga_background from 'assets/regularCompetition/laliga.jpg';
import laliga_logo from 'assets/regularCompetition/laliga.svg';
import laliga_header from 'assets/regularCompetition/laliga_header.jpg';
import laliga_header_desktop from 'assets/regularCompetition/laliga_header_desktop.jpg';
import premier_league_background from 'assets/regularCompetition/premier_league.jpg';
import premier_league_logo from 'assets/regularCompetition/premier_league.svg';
import premier_league_header from 'assets/regularCompetition/premier_league_header.jpg';
import premier_league_header_desktop from 'assets/regularCompetition/premier_league_header_desktop.jpg';

export enum RegularCompetition {
  CHAMPION = 'champion',
  CHALLENGER = 'challenger',
  CONTENDER = 'contender',
  LA_LIGA = 'laliga',
  PREMIER_LEAGUE = 'premier_league',
  BUNDESLIGA = 'bundesliga',
}

export enum RegularCompetitionDisplayName {
  CHAMPION = 'Champion',
  CHALLENGER = 'Challenger',
  CONTENDER = 'Contender',
  LA_LIGA = 'LALIGA EA SPORTS',
  PREMIER_LEAGUE = 'Premier League',
  BUNDESLIGA = 'Bundesliga',
}

export type RegularCompetitionItem = {
  slug: RegularCompetition;
  displayName: string;
  domesticLeagues: string[];
  svgLogoUrl: string;
  backgroundUrl: string;
  headerBackgroundUrl: string;
  headerDesktopBackgroundUrl?: string;
  iconUrl: string;
};

export const regularCompetitions: RegularCompetitionItem[] = [
  {
    slug: RegularCompetition.PREMIER_LEAGUE,
    displayName: RegularCompetitionDisplayName.PREMIER_LEAGUE,
    domesticLeagues: ['premier-league-gb-eng'],
    svgLogoUrl: premier_league_logo,
    iconUrl: premier_league_logo,
    backgroundUrl: premier_league_background,
    headerBackgroundUrl: premier_league_header,
    headerDesktopBackgroundUrl: premier_league_header_desktop,
  },
  {
    slug: RegularCompetition.LA_LIGA,
    displayName: RegularCompetitionDisplayName.LA_LIGA,
    domesticLeagues: ['laliga-es'],
    svgLogoUrl: laliga_logo,
    iconUrl: laliga_logo,
    backgroundUrl: laliga_background,
    headerBackgroundUrl: laliga_header,
    headerDesktopBackgroundUrl: laliga_header_desktop,
  },
  {
    slug: RegularCompetition.BUNDESLIGA,
    displayName: RegularCompetitionDisplayName.BUNDESLIGA,
    domesticLeagues: ['bundesliga-de'],
    svgLogoUrl: bundesliga_logo,
    iconUrl: bundesliga_logo,
    backgroundUrl: bundesliga_background,
    headerBackgroundUrl: bundesliga_header,
    headerDesktopBackgroundUrl: bundesliga_header_desktop,
  },
  {
    slug: RegularCompetition.CHAMPION,
    displayName: RegularCompetitionDisplayName.CHAMPION,
    domesticLeagues: [
      'premier-league-gb-eng',
      'laliga-es',
      'bundesliga-de',
      'serie-a-it',
      'ligue-1-fr',
    ],
    svgLogoUrl: champion_logo,
    iconUrl: champion_icon,
    backgroundUrl: champion_background,
    headerBackgroundUrl: champion_header,
    headerDesktopBackgroundUrl: champion_header_desktop,
  },
  {
    slug: RegularCompetition.CHALLENGER,
    displayName: RegularCompetitionDisplayName.CHALLENGER,
    domesticLeagues: [
      'eredivisie',
      'mlspa',
      'jupiler-pro-league',
      'spor-toto-super-lig',
      'campeonato-brasileiro-serie-a',
      'superliga-dk',
      'primeira-liga-pt',
      'football-league-championship',
    ],
    svgLogoUrl: challenger_logo,
    iconUrl: challenger_icon,
    backgroundUrl: challenger_background,
    headerBackgroundUrl: challenger_header,
    headerDesktopBackgroundUrl: challenger_header_desktop,
  },
  {
    slug: RegularCompetition.CONTENDER,
    displayName: RegularCompetitionDisplayName.CONTENDER,
    domesticLeagues: [
      '1-hnl',
      'austrian-bundesliga',
      '2-bundesliga',
      'premiership-gb-sct',
      'k-league-1',
      'j1-league',
      'segunda-division-es',
      'liga-mx',
      'superliga-argentina-de-futbol',
      'serie-b-it',
      'primera-division-cl',
      'ligue-2-fr',
      'liga-pro',
      'primera-division-peru',
      'chinese-super-league',
      'super-league-ch',
      'russian-premier-league',
      'eliteserien',
    ],
    svgLogoUrl: contender_logo,
    iconUrl: contender_icon,
    backgroundUrl: contender_background,
    headerBackgroundUrl: contender_header,
    headerDesktopBackgroundUrl: contender_header_desktop,
  },
];

export const mappedRegularCompetitions = regularCompetitions.reduce(
  (acc, competition) => ({
    ...acc,
    [competition.slug]: competition,
  }),
  {} as Record<RegularCompetition, RegularCompetitionItem>
);

export const leagueSlugsByCompetitionDisplayName = regularCompetitions.reduce(
  (acc, competition) => ({
    ...acc,
    [competition.displayName]: competition.domesticLeagues,
  }),
  {} as Record<string, string[]>
);
